import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import {
  DeleteEvent,
} from './styles';

const DATE_FORMAT = 'LT';
const FORMAT_24H = 'kk:mm';

const CalendarEvent = (props) => {
  const {
    event,
    timezone,
    toggleTime,
  } = props;

  const timeFormat = toggleTime ? FORMAT_24H : DATE_FORMAT;

  const start = moment.tz(event.startStr, timezone).format(timeFormat);
  const end = moment.tz(event.endStr, timezone).format(timeFormat);

  const handleDelete = () => {
    event.remove();
  };

  return (
    <>
      <DeleteEvent
        onClick={handleDelete}
      >
        X
      </DeleteEvent>
      <b>{`${start} - ${end}`}</b>
      <br />
      <b>Available for research</b>
    </>
  );
};

CalendarEvent.propTypes = {
  event: PropTypes.object.isRequired,
  timezone: PropTypes.string.isRequired,
  toggleTime: PropTypes.bool.isRequired,
};

export default CalendarEvent;
